export const data = {
  cloudinaryDir: 'f2f-landing/f2f-about-bg.jpg',
  alt: 'Boldare – team in the office kitchen',
};
